import { AuthLayout } from '../../Common/AuthLayout'
import LoginForm from './LoginForm'
import { withQueryParams } from '../../Helpers/withQueryParams'
import { TenantSummary } from './login.api'
import { ForgotPasswordResult } from '../app.reducer'

interface LoginProps {
  loginError: string,
  onLogin: $TSFIXME,
  onSingleSignOn: $TSFIXME,
  onConfirmForgotPassword: $TSFIXME,
  singleSignOnError: string,
  tenants: TenantSummary[],
  forgotPasswordResult: ForgotPasswordResult | null,
}

const Login = ({
  loginError,
  singleSignOnError,
  tenants,
  onLogin,
  onSingleSignOn,
  onConfirmForgotPassword,
  forgotPasswordResult,
}: LoginProps) => {
  return (
    <AuthLayout>
      <LoginForm
        loginError={loginError}
        singleSignOnError={singleSignOnError}
        tenants={tenants}
        onLogin={onLogin}
        onSingleSignOn={onSingleSignOn}
        onConfirmForgotPassword={onConfirmForgotPassword}
        forgotPasswordResult={forgotPasswordResult}
      />
    </AuthLayout>
  )
}

Login.defaultProps = {
  loginError: '',
  singleSignOnError: '',
  tenants: [],
}

export default withQueryParams(Login)
